"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputFieldSiblingType = void 0;
const types_1 = require("../../types/types");
const SIBLING_TYPES = {
    [types_1.InputFieldType.AFRR_UPPER_LIMIT]: types_1.InputFieldType.AFRR_LOWER_LIMIT,
    [types_1.InputFieldType.AFRR_LOWER_LIMIT]: types_1.InputFieldType.AFRR_UPPER_LIMIT,
    [types_1.InputFieldType.AFRR_POSITIVE]: types_1.InputFieldType.AFRR_NEGATIVE,
    [types_1.InputFieldType.AFRR_NEGATIVE]: types_1.InputFieldType.AFRR_POSITIVE,
    [types_1.InputFieldType.MFRR_UPPER_LIMIT]: types_1.InputFieldType.MFRR_LOWER_LIMIT,
    [types_1.InputFieldType.MFRR_LOWER_LIMIT]: types_1.InputFieldType.MFRR_UPPER_LIMIT,
    [types_1.InputFieldType.MFRR_POSITIVE]: types_1.InputFieldType.MFRR_NEGATIVE,
    [types_1.InputFieldType.MFRR_NEGATIVE]: types_1.InputFieldType.MFRR_POSITIVE,
    [types_1.InputFieldType.FLEX_PLUS_UPPER_LIMIT]: types_1.InputFieldType.FLEX_PLUS_LOWER_LIMIT,
    [types_1.InputFieldType.FLEX_PLUS_LOWER_LIMIT]: types_1.InputFieldType.FLEX_PLUS_UPPER_LIMIT,
};
function getInputFieldSiblingType(type) {
    return SIBLING_TYPES[type] ?? null;
}
exports.getInputFieldSiblingType = getInputFieldSiblingType;
